import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DialogService } from 'src/app/core';
import { ExerciceService } from 'src/app/exercice/src/exercice.service';
import { TrainingService } from '../../training.service';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
	templateUrl: './training-form.html',
})
export class TrainingFormDialog implements OnInit {
	exercice: [];
	form: FormGroup;
	exerciceCtrl: FormControl;
	weightCtrl: FormControl;
	repsCtrl: FormControl;
	user_id: number;
	training: any;
	deleteTime;
	constructor(private service: ExerciceService,
		private trainingService: TrainingService,
		private dialog: DialogService,
		@Inject(MAT_DIALOG_DATA) data
	) {
		this.training = (data.id ? data : undefined)

		if (data)
			this.user_id = data.user_id
	}

	ngOnInit() {
		this.initForm();
		this.service.getExerciceList(false).subscribe(
			(res: any) => this.exercice = res.exerciceList
		)
	}
	private initForm() {
		let exerciceCtrl = this.exerciceCtrl = new FormControl(null, Validators.required);
		let weightCtrl = this.weightCtrl = new FormControl(null, Validators.required);
		let repsCtrl = this.repsCtrl = new FormControl(null, Validators.required);

		this.form = new FormGroup({
			exerciceCtrl: exerciceCtrl,
			weightCtrl: weightCtrl,
			repsCtrl: repsCtrl
		});

		if (this.training) {
			exerciceCtrl.setValue(this.training.exercice_id)
			weightCtrl.setValue(this.training.weight)
			repsCtrl.setValue(this.training.reps)
		}
	}
	private delete(e: MouseEvent) {
		let t = e.type
		if (t == 'mousedown') {
			console.log('1')
			this.deleteTime = setTimeout(() => {
				this.trainingService.deleteTraining(this.training.id)
			}, 1000)
		}
		if (t == 'mouseup') {
			console.log('up')
			clearTimeout(this.deleteTime);
			this.deleteTime = 0
		}
	}
	private submit() {
		let form = this.form;
		form.value.user_id = this.user_id;
		if (form.valid) {
			if (this.training) {
				form.value.id = this.training.id;
				this.trainingService.updateTraining(form.value)
			} else {
				this.trainingService.createTraining(form.value)
			}

		} else {
			console.log('invalide')
		}
	}

}
